import React, { createContext, useState, useEffect } from 'react';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
    // 1. Estado del carrito
    const [cart, setCart] = useState(() => {
        const savedCart = localStorage.getItem('cart');
        return savedCart ? JSON.parse(savedCart) : [];
    });

    // 2. Estado para abrir/cerrar el panel lateral
    const [isCartOpen, setIsCartOpen] = useState(false);

    useEffect(() => {
        localStorage.setItem('cart', JSON.stringify(cart));
    }, [cart]);

    const addToCart = (product) => {
        setCart(prev => {
            const itemExistente = prev.find(item => item.id_carrito === product.id_carrito);
            if (itemExistente) {
                return prev.map(item => 
                    item.id_carrito === product.id_carrito 
                        ? { ...item, cantidad: item.cantidad + product.cantidad }
                        : item
                );
            }
            return [...prev, product];
        });
        
        // 🚨 LÍNEA COMENTADA PARA NO ABRIR EL CARRITO AUTOMÁTICAMENTE 🚨
        // setIsCartOpen(true); 
    };

    const removeFromCart = (productId) => {
        setCart(prev => prev.filter(item => item.id_carrito !== productId));
    };

    // <-- NUEVO: Función para sumar o restar unidades específicas -->
    const updateQuantity = (productId, delta) => {
        setCart(prev => prev.map(item => {
            if (item.id_carrito === productId) {
                const nuevaCantidad = item.cantidad + delta;
                // Evitamos que baje de 1 unidad (si quiere 0, que use el botón de borrar)
                return { ...item, cantidad: nuevaCantidad > 0 ? nuevaCantidad : 1 };
            }
            return item;
        }));
    };

    // <-- NUEVO: Función para vaciar todo el carrito (Cancelar Pedido) -->
    const clearCart = () => {
        setCart([]);
        setIsCartOpen(false);
    };

    return (
        <CartContext.Provider value={{ 
            cart, 
            addToCart, 
            removeFromCart, 
            updateQuantity, 
            clearCart,
            isCartOpen, 
            setIsCartOpen 
        }}>
            {children}
        </CartContext.Provider>
    );
};